import { notification } from "antd";
import Form from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import Modal from "antd/lib/modal/Modal";
import { observer } from "mobx-react";
import moment from "moment";

import React, { createContext, useContext } from "react";
import { useState } from "react";
import _ from "underscore";
import RequestStore from "../approvals/store/requeststore";

const requestStoreCtx = createContext(RequestStore);
export const CancellationDialog = observer(() => {
  const requestStore = useContext(requestStoreCtx);
  const [reason, setReason] = useState("");
  return (
    <Modal
      visible={requestStore.showCancellationDialog}
      okText="Cancel Request"
      title="Sign-Off Request Cancellation"
      okButtonProps={{
        disabled: _.isEmpty(reason),
        loading: requestStore.isLoading,
      }}
      onCancel={() => {
        requestStore.showCancellationDialog = false;
      }}
      onOk={async () => {
        try {
          const req = await requestStore.cancelRequest(
            requestStore.selReqItem.requestApprovalId,
            reason
          );
          requestStore.myRequests.delete(req.requestApprovalId);
          requestStore.showCancellationDialog = false;
          requestStore.selReqItem = {};
          notification.success({
            message: "SPARS Feedback",
            description: `request cancelled successfully with notifications sent`,
          });
        } catch (error) {
          notification.error({
            message: "SPARS Feedback",
            description: error.message,
          });
        }
      }}
    >
      <Form layout="vertical">
        <FormItem label="Asset:">
          <borderTop>{requestStore.selReqItem.asset}</borderTop>
        </FormItem>
        <FormItem label="Production(Refer) Date:">
          <b>
            {moment(requestStore.selReqItem.productionDate).format(
              "Do dddd, MMMM YYYY"
            )}
          </b>
        </FormItem>
        <FormItem label="Cancellation Reason" labelAlign="top">
          <TextArea
            onChange={({ target }) => {
              setReason(target.value);
            }}
            rows={10}
          ></TextArea>
        </FormItem>
      </Form>
    </Modal>
  );
});

